import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddBillingRuleForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddBillingRuleForm";
import AddEVRuleForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddEVRuleForm";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import CustomTabs from "../../components/UI/Tabs/CustomTabs/CustomTabs";
import { TabItemEntity } from "../../entities/UIEntities/TabItem";
import { ROLES_HIERARCHY, TABLES } from "../../enums/Enums";
import useBillingService from "../../hooks/useBillingService";
import { commonActions } from "../../redux/reducers/CommonReducer";
import store from "../../redux/Store";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import classes from "./BillingPage.module.css";

const BillingPage = () => {
  const billingRules = useSelector((state) => state.billing.billingRules);
  const validationHistoriesData = useSelector((state) => state.billing.validationHistoriesData);
  const selectedSites = useSelector((state) => state.user?.selectedSites);

  // show button if there is atleast one IsBillingEnabled on one of the billingRule's sites 
  // const showBillingButton = billingRules.some(br => br?.site?.isBillingEnabled); 

  // show button if there is atleast one IsBillingEnabled on one of the selectedSites
  const showBillingButton = selectedSites.some(site => site?.isBillingEnabled);

  const gmtUser = useSelector((state) => state.user.gmtUser);
  const [tableName, setTableName] = useState(Strings.TABS_NAMES.BILLING_RULES);
  let tabs = [];

  const { getEvRulesDataTable, getBillingRulesDataTable, getBillingValidationHistoryDataTable } = useBillingService();

  const [billingRulesTab, setBillingRulesTab] = useState(
    new TabItemEntity(
      Strings.TABS_NAMES.BILLING_RULES,
      TABLES.BILLING_RULES,
      getBillingRulesDataTable()
    )
  );

  const [evRulesTab, setEvRulesTab] = useState(
    new TabItemEntity(
      Strings.TABS_NAMES.EV_RULES,
      TABLES.EV_RULES,
      getEvRulesDataTable()
    )
  );

  const [validationHistoryTab, setValidationHistoryTab] = useState(
    new TabItemEntity(
      Strings.TABS_NAMES.VALIDATION_HISTORY,
      TABLES.BILLING_HISTORY,
      getBillingValidationHistoryDataTable()
    )
  );

  useEffect(() => {
    setBillingRulesTab(
      new TabItemEntity(
        Strings.TABS_NAMES.BILLING_RULES,
        TABLES.BILLING_RULES,
        getBillingRulesDataTable()
      )
    );

    setEvRulesTab(
      new TabItemEntity(
        Strings.TABS_NAMES.EV_RULES,
        TABLES.EV_RULES,
        getEvRulesDataTable()
      )
    );
  }, [billingRules]);

  useEffect(() => {
    setValidationHistoryTab(
      new TabItemEntity(
        Strings.TABS_NAMES.VALIDATION_HISTORY,
        TABLES.BILLING_HISTORY,
        getBillingValidationHistoryDataTable()
      )
    );
  }, [validationHistoriesData]); 

  tabs = [billingRulesTab, evRulesTab, validationHistoryTab];

  const handleTabChanged = (tableName) => {
    setTableName(tableName);
  };

  const handleModalOpen = () => {
    if (tableName === Strings.TABS_NAMES.BILLING_RULES) {
      store.dispatch(
        commonActions.setSideModal({ modalContent: <AddBillingRuleForm /> })
      );
    } else {
      store.dispatch(
        commonActions.setSideModal({ modalContent: <AddEVRuleForm /> })
      );
    }
  };

  return (
    <div className={classes.parkersPage}>
      <Grid container spacing={4} className={classes.parkersContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.BILLING2}
            pageTitle={Strings.TITLES.BILLING_PAGE}
            buttonText={
              tableName === Strings.TABS_NAMES.BILLING_RULES
                ? Strings.ADD_RULE
                : Strings.ADD_EV_RULE
            }
            validRole={
              gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.ADMINISTRATOR /*&& showBillingButton*/
            }
            disableDisplay={tableName === Strings.TABS_NAMES.BILLING_RULES || tableName === Strings.TABS_NAMES.EV_RULES ? !showBillingButton : true}
            handleModalOpen={handleModalOpen}
          />
          {tabs && (
            <CustomTabs
              initialTab={Strings.TABS_NAMES.BILLING_RULES}
              tabs={tabs}
              onTabChange={handleTabChanged}
            ></CustomTabs>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default BillingPage;
